<template>
  <div
    id="hekate-loader"
    :class="{
      'hekate-loader d-none': true,
    }"
  >
    <div
      :class="{
        'formfort-loading': true,
      }"
    ></div>
  </div>
</template>
